<template>
  <div style="display: flex; width: 100%">
    <el-select
      v-model="fileNameSelected"
      :placeholder="$t('filesSelect.files')"
      filterable
      :disabled="disabled"
    >
      <el-option label="result.log" value="result.log"></el-option>
      <el-option
        v-for="(fileName, index) in getFilesNames"
        :key="index"
        :label="fileName"
        :value="fileName"
      ></el-option>
    </el-select>
    <el-button
      @click="filesClick"
      size="mini"
      :disabled="!fileNameSelected"
      style="margin-left: 1px"
      >{{ $t('filesSelect.download') }}</el-button
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      fileNameSelected: null,
    };
  },
  props: {
    queueId: Number,
    disabled: Boolean,
    autoDownload: Boolean,
  },
  methods: {
    filesClick() {
      //console.log(this.fileNameSelected);
      //dummy test for getting file from server
      if (this.fileNameSelected) {
        this.$store
          .dispatch("getResultLog", {
            type: "blob",
            queueId: this.queueId,
            fileName: this.fileNameSelected,
          })
          .then(() => {
            let href = window.URL.createObjectURL(this.getRTRetFile);
            //создается выпадающее окно со ссылкой на файл
            var link = document.createElement("a");
            link.setAttribute("href", href);
            link.setAttribute("download", this.fileNameSelected);
            document.body.appendChild(link); // Required for FF

            link.click(); // This will download the data file named "my_data.csv"
            this.$store.commit("setLoading", false);
          });
      }
    },
  },
  computed: {
    ...mapGetters(["getRTRetFile", "getFilesNames"]),
  },
  watch: {
    autoDownload(val) {
      if (val && this.getFilesNames) {
        if (this.getFilesNames.length > 1) {
          this.$message(
            this.$t('tasks.moreThanOneSignificantFile')
          );
          return;
        }
        if (this.getFilesNames.length === 0) return;
        this.$store.commit("setLoading", true);
        this.fileNameSelected = this.getFilesNames[0];
        this.filesClick();
      }
    },
    getFilesNames() {
      if (this.getFilesNames.length === 0) this.fileNameSelected = null;
    },
  },
};
</script>

<style scoped>
.el-select {
  flex-grow: 1;
}
</style>